import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FunctionCallService } from 'src/app/shared/services/function-calls.service';
// import { WebSocketService } from 'src/app/shared/services/websocket.service';

@Component({
  selector: 'app-director-landing-page',
  templateUrl: './director-landing-page.component.html',
  styleUrls: ['./director-landing-page.component.css']
})
export class DirectorLandingPageComponent implements OnInit {

  constructor(private functionCallService: FunctionCallService,
              private authService: AuthService,
              ) { }

  ngOnInit(): void {


  }

  setupDeviceInfo()  
  {
    alert();
  }


  getBrowserInfo()  
  {
    this.functionCallService.getBrowserInfoService('getBrowserInfo');
  }


  // Log the User Out by removing the token from Local Storage
  logout()
  {
    this.authService.logout();
  }


}
